import {
  GET_SOLUTIONS,
  GET_SOLUTIONS_SUCCESS,
  GET_SOLUTIONS_FAIL,
  ADD_SOLUTION,
  ADD_SOLUTION_SUCCESS,
  ADD_SOLUTION_FAIL,
  UPDATE_SOLUTION,
  UPDATE_SOLUTION_SUCCESS,
  UPDATE_SOLUTION_FAIL,
  DELETE_SOLUTION,
  DELETE_SOLUTION_SUCCESS,
  DELETE_SOLUTION_FAIL
} from './actionTypes';

// ---------------- GET ----------------
export const getSolutions = () => ({ type: GET_SOLUTIONS });
export const getSolutionsSuccess = (solutions) => ({
  type: GET_SOLUTIONS_SUCCESS,
  payload: solutions,
});
export const getSolutionsFail = (error) => ({
  type: GET_SOLUTIONS_FAIL,
  payload: error,
});

// ---------------- ADD ----------------
export const addSolution = (data,onClose) => ({ type: ADD_SOLUTION,payload:{data,onClose} });
export const addSolutionSuccess = (solution) => ({
  type: ADD_SOLUTION_SUCCESS,
  payload: solution,
});
export const addSolutionFail = (error) => ({
  type: ADD_SOLUTION_FAIL,
  payload: error,
});

// ---------------- UPDATE ----------------
export const updateSolution = (data,onClose) => ({ type: UPDATE_SOLUTION ,payload:{data,onClose}});
export const updateSolutionSuccess = (solution) => ({
  type: UPDATE_SOLUTION_SUCCESS,
  payload: solution,
});
export const updateSolutionFail = (error) => ({
  type: UPDATE_SOLUTION_FAIL,
  payload: error,
});

// ---------------- DELETE ----------------
export const deleteSolution = (id) => ({ type: DELETE_SOLUTION,payload:id });
export const deleteSolutionSuccess = (solutionId) => ({
  type: DELETE_SOLUTION_SUCCESS,
  payload: solutionId,
});
export const deleteSolutionFail = (error) => ({
  type: DELETE_SOLUTION_FAIL,
  payload: error,
});
